import type { Rules } from "../../types";
import { limits, ultimateRequirement } from "./limits";
import { wealthLevels } from "./wealthLevels";
import { coreSkills } from "./coreSkills";
import { darkOfferings } from "./darkOfferings";
import { patrons } from "./patrons";
import { otherworldlyGifts } from "./otherworldlyGifts";
import { spellLists } from "./spells";
import { festiveGames } from "./festiveGames";
import { cabals } from "./cabals";

export const rulesV2: Rules = {
  metadata: {
    version: "2.0.0",
    label: "Game 2",
    releasedAt: "2026-10-10",
    description: "Ultimate Warlock LARP - Game Two (2027) rules",
  },
  limits,
  wealthLevels,
  ultimateRequirement,
  coreSkills,
  darkOfferings,
  patrons,
  otherworldlyGifts,
  spellLists,
  festiveGames,
  cabals,
};
